import type { SeasonGridRow } from '../types'

/**
 * The season row (team + season) a click should expand or collapse — only
 * season rows with a known season id toggle; game, loading and career rows do
 * nothing. Keyed on the row, not the season: a player on two teams in one
 * schedule has two rows for it.
 */
export const getToggleSeasonRowId = (
  row: SeasonGridRow | undefined
): string | null =>
  row?.kind === 'season' && row.seasonId !== '' ? row.id : null
